import { ChrDeposit } from "../../classes/ChrDeposit";
import { eChromiaActionTypes } from "../../store/chromia/chromiaTypes";
import { store } from "../../store/store";
import { getAllLaunchesQuery, getAllPeriodsQuery, getClientDeposQuery } from "./queries";


export const updateDeposits = async () => {
	const { discountPercent } = store.getState().app;
	const { chrClientAddr } = store.getState().chromia;

	if (!chrClientAddr) return;

	const deposits = await getClientDeposQuery(chrClientAddr);
	const periods = await getAllPeriodsQuery();
	// const launches = await getAllLaunchesQuery();

	// const res = deposits.map(deposit => new ChrDeposit(deposit, periods, launches));
	const res = deposits.map(deposit => new ChrDeposit(deposit, periods));
	// console.log('client deposits: ', res);

	store.dispatch({
		type: eChromiaActionTypes.SET_DEPOSITS,
		payload: {
			percent: discountPercent,
			deposits: res
		}
		// payload: deposits.map(deposit => new ChrDeposit(deposit, periods, launches))
	});
}